



















































































































import { Component, Vue, Prop, Watch, Mixins } from 'vue-property-decorator';
import AttributeModel, { AttributeFilterParams, SelectedAttributeModel } from '@/models/AttributeModel';
import Attribute from '@/components/Attribute.vue';
import ConfigurationService from '@/services/configuration.service';
import { AttributeTypes } from '@/common/enum';
import VehicleDetail from '@/models/VehicleDetail';
import Shared from '@/common/shared';
import { getModule } from 'vuex-module-decorators';
import StoreVuexModule from '@/stores/StoreVuexModule';
import BaseServiceMixin from '@/mixins/base.service.mixin';

@Component({
  name: 'Configuration',
  components: {
    Attribute,
  },
})
export default class Configuration extends Mixins(BaseServiceMixin) {
  @Prop({ default: undefined })
  public vehicleData!: VehicleDetail;
  private data: AttributeModel[] = [];
  // private title: string = '';
  // private step: number = 1;
  private selected: AttributeModel = new AttributeModel();
  private selectedAttributes: SelectedAttributeModel[] = [];
  // private isShowSelected: boolean = false;
  private attributeSettings = Shared.AttributeSettings;
  private attributeTypes = AttributeTypes;

  private active: any = {};

  private store = getModule(StoreVuexModule, this.$store);

  private configurationService!: ConfigurationService;

  public created() {
    this.configurationService = new ConfigurationService(this.axiosInstance);
  }

  private mounted() {
    this.reset();
  }

  private get noProgress(): boolean {
    return this.store.noProgress;
  }

  private get noBack(): boolean {
    return this.store.noBack;
  }

  private get process(): number {
    return ((this.active.index || 1) * 100) / this.attributeSettings.length;
  }

  @Watch('vehicleData', { deep: true })
  private updateInternalStorage() {
    this.reset();
  }

  private async reset() {
    this.selectedAttributes.length = 0;
    this.selected = new AttributeModel();

    this.active = {};
    try {
      await this.next();
    } catch (err) {
      // handle error
    }
  }

  private async next() {
    const nextIndex = (this.active.index || 0) + 1;

    if (nextIndex > Shared.AttributeSettings.length) {
      this.active = {};
      this.$emit('setSelectedAttributes', this.selectedAttributes);
      return;
    }
    try {
      await this.setActiveAttribute(this.active, nextIndex);

      if (!this.data.length) {
        await this.next();
      }
    } catch (err) {
      // handle error
    }
  }

  private async setActiveAttribute(active: any, nextIndex: number) {
    this.data = [];
    const activeAttributeType = active.attributeType;
    const activeIndex = active.index;

    this.active = Shared.AttributeSettings.find((a) => a.index === nextIndex);

    // show child if parent is selected
    if (this.active.parent === activeIndex && !this.selectedAttributes.find((a) => a.type === activeAttributeType)) {
      return;
    }
    try {
      if (this.active.type === 'product') {
        this.data = await this.getProductAttributes();
      } else {
        this.data = await this.getAttributes();
      }
    } catch (err) {
      // handle error
    }

    this.scroll();
  }

  private async getProductAttributes(): Promise<AttributeModel[]> {
    let data: AttributeModel[] = [];
    try {
      data = await this.configurationService.GetFilteredAttributes(this.active.attributeType, this.getFilteredParam());
    } catch (error) {
      // error
    }

    return data ? data : [];
  }

  private async onSelectedAttribute(attribute: SelectedAttributeModel) {
    const attributeSetting = Shared.AttributeSettings.find((a) => a.attributeType === attribute.type);

    if (attributeSetting) {
      const active = Shared.AttributeSettings.find((a) => a.index === attributeSetting.index - 1);
      try {
        this.selected = attribute;
        this.setSelectedAttribute(attribute);
        await this.setActiveAttribute(active || {}, attributeSetting.index);
      } catch (err) {
        // handle error
      }
    }
  }

  // @Watch('selected', { deep: true })
  // private updateInternalStore() {
  //   if (Object.keys(this.selected).length > 0) {
  //     this.selectConfiguration();
  //   }
  // }

  // emitted event from child
  private selectAttribute(attribute: AttributeModel) {
    this.selected = attribute;
    this.setSelectedAttribute(attribute);
    this.selected = new AttributeModel();

    this.next();
  }

  private getFilteredParam() {
    // tslint:disable-next-line:max-line-length
    const attributes = this.selectedAttributes.filter(
      (a) => a.type === AttributeTypes.CarpetSpec || a.type === AttributeTypes.Trim,
    );

    return attributes.map((a) => {
      const attributeFilterParam: AttributeFilterParams = new AttributeFilterParams();

      attributeFilterParam.attributeId = a.id;
      attributeFilterParam.type = a.type;

      return attributeFilterParam;
    });
  }

  private setSelectedAttribute(attribute: AttributeModel) {
    const selected: SelectedAttributeModel = Object.assign(this.selected, {
      title: this.active.title,
    });

    const attributeSetting = Shared.AttributeSettings.find((a) => a.attributeType === attribute.type);

    if (attributeSetting) {
      const selectedAttributeTypes: AttributeTypes[] = Shared.AttributeSettings.filter(
        (a) => a.index < attributeSetting.index,
      ).map((a) => a.attributeType);

      const selectedAttributes = this.selectedAttributes.filter((a) =>
        selectedAttributeTypes.some((s) => s === a.type),
      );
      selectedAttributes.push(selected);

      this.selectedAttributes = selectedAttributes;
    }
  }

  private async getAttributes(): Promise<AttributeModel[]> {
    const parent = Shared.AttributeSettings[this.active.parent - 1];
    const selectedAttribute = this.selectedAttributes.find((a) => a.type === parent.attributeType);

    if (!selectedAttribute) {
      return [];
    }

    let data: AttributeModel[] = [];
    try {
      data = await this.configurationService.GetAttributes(selectedAttribute.id, this.active.attributeType);
    } catch (error) {
      // error
    }

    return data;
  }

  private scroll() {
    this.$vuetify.goTo(this.$refs.configuration as any, {
      duration: 750,
      offset: 56,
      easing: 'linear',
    });
  }

  private getAttributeTypeTitle(attribute: any) {
    switch (attribute.attributeType) {
      case AttributeTypes.CarpetSpec:
        return 'Select your preferred material';
      case AttributeTypes.CarpetColor:
        return 'Select your preferred colour';
      case AttributeTypes.Trim:
        return 'Select your preferred trim';
      case AttributeTypes.TrimColor:
        return 'Select your preferred trim colour';
      case AttributeTypes.HeelPad:
        return 'Select your prefered heelpad';
    }
    return attribute.title;
  }
}
